import { post } from 'aws-amplify/api';



// Cache of clue suggestion objects, to avoid bombarding API with multiple identical requests
const clueSuggestionCache = { };  // word: { answer, type, notes?, clueOptions: [ string ] }
let currentWord = null;           // the most recent word to be requested, to help determine if returned async responses are still relevant or not

// Throttle timestamp tracker
let lastCallTime = 0;

/**
 * Calls backend API to generate clue suggestions from word. Returns a full analysis along with one or more clue options.
 * If null is returned, then either it was not able to get a suggestion, or it's already stale and doesn't recommend updating the UI anymore.
 * @param {string} word 
 * @returns { Promise<{ answer, type, notes?, clueOptions: [string] } | null> } answer: should match word; type: what type of word is it (proper noun, etc.), notes: notes on usage in crosswords
 */
export async function suggestClue(word) {
  currentWord = word;

  if (clueSuggestionCache[word]) {
    return clueSuggestionCache[word];
  }

  try {
    const now = Date.now();
    if (now - lastCallTime < 100) return null;
    lastCallTime = now;

    const returnedVal = await (await post({
      apiName: 'suggestorEngine',
      path: '/clue',
      options: {
        body: {
          word: word.toUpperCase(),
        },
      },
    }).response).body.json();

    if (!returnedVal || !returnedVal.answer || !returnedVal.type || !returnedVal.clueOptions || returnedVal.clueOptions.length < 1) {
      console.warn('Unexpected response for word ' + word);
      return null;
    }

    clueSuggestionCache[word] = returnedVal;
    if (word === currentWord) {
      return returnedVal;
    }
    return null;
  } catch (e) {
    console.warn(e);
    return null;
  }

}



// const acceptSuggestionShortcut = new ShortcutDefinition(true, false, 'Enter');
// const placeholderSuffix = '   (' + acceptSuggestionShortcut.displayString + ')';

// export function toPlaceholder(clueText) {
//   return clueText + placeholderSuffix;
// }







